import { createSlice } from '@reduxjs/toolkit';
import ProductInformationAPI from '~/api/product-information-api';
import type AssetTypeConstants from '~/constants/asset-type-constants';
import createCaughtAsyncThunk from '~/utils/create-action/create-caught-async-thunk';
import { defaultState } from './data/AssetTypesState';
import {
  createCategories,
  createInitAssetTypesDataMap,
} from './data/data-creator';

export const getAssetTypes = createCaughtAsyncThunk<any>(
  'getAssetTypes',
  async () => {
    return await ProductInformationAPI.getAssetTypes();
  }
);

export const getAssetTypeData = createCaughtAsyncThunk<any, AssetTypeConstants>(
  'getAssetTypeData',
  async (args) => {
    return await ProductInformationAPI.getProductInformation(args);
  }
);

const slice = createSlice({
  name: 'asset-types',
  initialState: defaultState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAssetTypes.pending, (state) => {
        state.isLoading = true;
        delete state.error;
      })
      .addCase(getAssetTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.assetTypes = action.payload;
        state.assetTypesData = createInitAssetTypesDataMap(action.payload);
      })
      .addCase(getAssetTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(getAssetTypeData.pending, (state, action) => {
        state.assetTypesData[action.meta.arg].isLoading = true;
        delete state.error;
      })
      .addCase(getAssetTypeData.fulfilled, (state, action) => {
        state.assetTypesData[action.meta.arg].isLoading = false;
        state.assetTypesData[action.meta.arg].categories = createCategories(
          action.payload
        );
      })
      .addCase(getAssetTypeData.rejected, (state, action) => {
        state.assetTypesData[action.meta.arg].isLoading = false;
        state.error = action.payload;
      });
  },
});

export default slice.reducer;
